export default {
  footer: {
    /* eslint-disable-next-line @typescript-eslint/camelcase */
    sc_o: 'navigation_footer',
  },
};
